import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { TESTIMONIOS } from '../../data/retiro';
export function Testimonios() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'rgba(247,220,120,0.12)'
  }} data-id="element-174">
      <div className="mx-auto max-w-7xl" data-id="element-175">
        <SectionHeading eyebrow="Transformación Real" title="Palabras que Nacen del Alma" data-id="element-176" />

        <div className="mt-16 grid gap-6 md:grid-cols-3" data-id="element-177">
          {TESTIMONIOS.map((t, i) => <Reveal key={t.autor} delay={i * 0.1} data-id="element-178">
              <figure className="flex h-full flex-col rounded-3xl bg-white p-8 shadow-sm" data-id="element-179">
                <QuoteIcon className="h-8 w-8" style={{
              color: 'rgba(200,153,46,0.4)'
            }} aria-hidden data-id="element-180" />
                <blockquote className="mt-4 flex-1 font-heading text-lg font-light italic leading-relaxed" style={{
              color: 'var(--ink)'
            }} data-id="element-181">
                  "{t.texto}"
                </blockquote>
                <figcaption className="mt-6 text-sm font-medium" style={{
              color: 'var(--darkgoldenrod)'
            }} data-id="element-182">
                  — {t.autor}
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}